export enum ClubConfirmationEnum {
    Save=1,
    Cancel = 2,
    Replace = 3,
}